import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from 'src/app/modals/Authentication/auth.models';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecords } from './payments.action';

@Injectable({ providedIn: 'root' })
export class PaymentsTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                id: '',
                created_at: '',
                member_id: '',
                member_name: '',
                team: '',
                address: '',
                amount: ''
            };

    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'id';
    initialSortDirection = 'desc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    hasFilter = false;
    clubId = 0;
    batchId = "0";
    batchNumber = "";
    columns = [
                { prop: 'id', name: 'PAYMENT.id', sortable: true, hasFilter: true, filter: "input", widthSet: 70},
                { prop: 'created_at', name: 'PAYMENT.date', sortable: true, hasFilter: true, filter: "date", widthSet: 155},
                { prop: 'member_id', name: 'PAYMENT.member-id', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'member_name', name: 'PAYMENT.member-name', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'team', name: 'PAYMENT.team', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'address', name: 'PAYMENT.address', sortable: true, hasFilter: false, filter: "input", widthSet: 450},
                { prop: 'amount', name: 'PAYMENT.amount', sortable: true, hasFilter: true, filter: "input"},
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchRecords());
    }

    hasActiveFilters(){

        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;

    }

    resetState(){
        this.filters = {
            id: '',
            created_at: '',
            member_id: '',
            member_name: '',
            team: '',
            address: '',
            amount: ''
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;
    }

    resetFilters(){
        this.resetState();
        this.loadRecords();
    }

}